<script setup>
import { ref, onMounted, nextTick } from 'vue'
import { $router } from '@/router'
import { $bus } from '@/common/events'
import { dialog } from '@/common/dialog'
import { useTitle } from '@/composables/title'
import { useMenu, useSubmenu, useTopBar } from '@/composables/menu'

async function startVideoTest() {
  isVideoTest.value = true;

  await nextTick();

  let player = document.getElementById("player");
  player.width = window.innerWidth;
  player.height = window.innerHeight;
}

onMounted(() => {
  useTitle("Bandwidth");
  useMenu("admin");
  useSubmenu(false);
  useTopBar(true);
})

function goBack() {
  try {
    $router.push({ name: "Admin" });
  }
  catch (err) {
    dialog(err);
  }
}
</script>

<template>
  <div class="relative dark:bg-gray-900 dark:text-white p-5">

    <div class="w-full mx-auto flex items-center justify-between">
      <div class="text-lg font-bold dark:text-white">{{ $t('admin.bandwidth_title') }}</div>
      <div class="flex flex-row justify-items-strech space-x-2">
        <Button type="secondary" @click="goBack()">{{ $t('generic.back') }}</Button>
      </div>
    </div>

    <div class="h-screen">
      <iframe src="http://speedtest.omara.plt.si/" style="width:100%; height:100%; border:none; margin:0; padding:0;"></iframe>
    </div>
  </div>
</template>

<style scoped>
</style>
